/**
 * `domains` — routage et TLS (base plateforme, 4.1 ; D3).
 */
import { z } from 'zod';
import { CHAMPS_DOCUMENT, idSchema, withAudit } from './commun.js';
export const ETATS_DOMAINE = ['a_verifier', 'actif', 'erreur', 'retire'];
export const etatDomaineSchema = z.enum(ETATS_DOMAINE);
export const ETATS_CERTIFICAT = ['absent', 'en_cours', 'emis', 'expire', 'erreur'];
export const etatCertificatSchema = z.enum(ETATS_CERTIFICAT);
export const certificatSchema = z.object({
    etat: etatCertificatSchema.default('absent'),
    emisLe: z.date().optional(),
    expireLe: z.date().optional(),
    derniereErreur: z.string().optional(),
});
export const domainSchema = withAudit(z.object({
    _id: idSchema,
    hote: z.string().regex(/^[a-z0-9.-]+\.[a-z]{2,}$/, "Nom d'hôte attendu, en minuscules."),
    galerieId: idSchema,
    principal: z.boolean().default(false),
    etat: etatDomaineSchema.default('a_verifier'),
    certificat: certificatSchema,
    verifieLe: z.date().optional(),
}));
export const domainCreationSchema = domainSchema.omit({
    ...CHAMPS_DOCUMENT,
    certificat: true,
    verifieLe: true,
});
export const domainMiseAJourSchema = domainCreationSchema.omit({ galerieId: true }).partial();
//# sourceMappingURL=domains.js.map